module.exports = __webpack_public_path__ + "img/Yinghao_Wu-500x500.dc37e220.jpg";